import { quoteLineType } from '../../types'
import { ImpresCatalogItem, ImpresSupplierOffer } from './impresTypes'
import { productTypeForCategory } from '../../EditQuote/lines/productCategories'

// These have to match the dropdown options in src/lists.ts exactly, since that's what
// the quote form uses to show which distributor a line item came from.
const PROVIDER_BY_SUPPLIER: Record<ImpresSupplierOffer['supplierName'], string> = {
  'TD Synnex': 'TD SYNNEX Corp.',
  'Ingram Micro': 'Ingram Micro',
  Carahsoft: 'Carahsoft',
  Dell: 'Dell, Inc.',
}

export function impresItemToLineItem(
  lineNumber: number,
  mfgPN: string,
  item: ImpresCatalogItem,
  supplierName: ImpresSupplierOffer['supplierName'],
  qty: number,
): Partial<quoteLineType> {
  // Which supplier to use comes from the caller (the card's quantity selector)
  // the user might want the cheapest offer, not just whichever supplier we'd default to.
  const supplier = item.suppliers.find(s => s.supplierName === supplierName)
  if (!supplier) throw new Error(`No ${supplierName} offer found for ${mfgPN}`)

  return {
    LineItemId: crypto.randomUUID(),
    LineNumber: lineNumber,
    Bundle: null,
    Provider: PROVIDER_BY_SUPPLIER[supplier.supplierName],
    Manufacturer: item.manufacturer,
    MfrPartNumber: mfgPN,
    VendorPartNumber: supplier.supplierPartNumber,
    Description: item.description,
    Qty: qty,
    UnitCost: supplier.unitPrice,
    MSRP: item.msrp,
    ProductType: productTypeForCategory(item.productCategory),
    ProductCategory: item.productCategory,
    ProductCategorySource: item.productCategorySource,
    ProductCategoryConfidence: item.productCategoryConfidence,
    TAA: item.taa,
    CountryOfOrigin: item.countryOfOrigin,
    UPC: item.upc,
    UNSPSC: item.unspsc,
    EnergyStar: item.energyStar,
    EPEAT: item.epeat,
  }
}
